import { render, staticRenderFns } from "./remitDataShopee.vue?vue&type=template&id=9cb2e430&scoped=true"
import script from "./remitDataShopee.vue?vue&type=script&lang=js"
export * from "./remitDataShopee.vue?vue&type=script&lang=js"
import style0 from "./remitDataShopee.vue?vue&type=style&index=0&id=9cb2e430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb2e430",
  null
  
)

export default component.exports